import React from 'react';
import PropTypes from 'prop-types';
import cancel from '../assets/cancel.png';

/**
 * Reusable modal overlay shell with title bar and close button.
 * Extracted to eliminate code duplication across EventModal and CategoryModal.
 */
const ModalShell = ({ title, onClose, children }) => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-campus-surface p-6 rounded-2xl shadow-soft relative w-full max-w-lg mx-4 overflow-y-auto" style={{ maxHeight: '80vh' }}>
            <div className="flex justify-between items-center mb-4">
                <h3 className="text-xl font-heading font-bold text-campus-primary">{title}</h3>
                <button
                    type="button"
                    onClick={onClose}
                    className="text-white rounded transition-opacity hover:opacity-75"
                >
                    <img src={cancel} width="25px" alt="close" />
                </button>
            </div>
            {children}
        </div>
    </div>
);

ModalShell.propTypes = {
    title: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
};

export default ModalShell;
